'use client';

import React from 'react'

// Components
import { Footer, Header } from "@src/components/company-page"
import { Hero, AboutCentury, AboutCenturyIndonesia } from "@src/components/about-us"

const Page = () => {
  return (
    <div>
      <Header />
      <Hero />
      <AboutCentury />
      <AboutCenturyIndonesia />
      <Footer />
    </div>
  )
}

export default Page